//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Builder.js";
import "../no/SelectObjectList.js";
import "../no/SelectObjectList.js";
let d=[[[0,"AngleTolerance",1,0],[0,"ApplyRemoteConstraints",1,0],[0,"Coincident",1,0],[0,"Collinear",1,0],[0,"Concentric",1,0],[1,"CurveList",0,"SelectObjectList",0],[0,"DistanceTolerance",1,0],[0,"EqualLength",1,0],[0,"EqualRadius",1,0],[0,"Horizontal",1,0],[0,"Parallel",1,0],[0,"Perpendicular",1,0],[0,"PointOnCurve",1,0],[0,"Tangent",1,0],[0,"Vertical",1,0]],[[[],"SetAllConstraints",{},0,0],[[],"ClearAllConstraints",{},0,0]],[]];
SPLM.SketchAutoConstrainBuilder = class extends SPLM.Builder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.SketchAutoConstrainBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;